require('./juniorInterveners.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ components
const IntervenerRow = require('./intervenerRow/intervenerRow');

class JuniorInterveners extends React.Component {

    constructor(props) {
        super(props);
        this.handleRestoreDefaultInterveners = this.handleRestoreDefaultInterveners.bind(this);
    }

    buildIntervenersRows () {
        const {
            immJuniorInterveners,
            onTypeChange,
            onExclude
        } = this.props;
        return immJuniorInterveners.map((intervener, index) => {
            const showRemoveButton = intervener.get('currentIntervener') ? false : immJuniorInterveners.size > 1;
            return (
                <IntervenerRow
                    id={index}
                    intervenerName={intervener.get('name')}
                    key={index}
                    onTypeChange={onTypeChange}
                    onExclude={onExclude}
                    relationship={intervener.get('relationship')}
                    showError={intervener.get('error')}
                    showRemoveButton={showRemoveButton}
                />
            );
        });
    }

    buildRestoreDefaultIntervenersLink(){
        const restoreValuesLabel = formatText('broker-stockIntervenerRestoreValuesLabel');
        return (
            <a className="contracts-account-interveners__action-links" onClick={this.handleRestoreDefaultInterveners}>
                {restoreValuesLabel}
            </a>
        );
    }

    handleRestoreDefaultInterveners(e) {
        e.preventDefault();
        const { restoreDefaultInterveners, immContract } = this.props;
        restoreDefaultInterveners(immContract.get('intervenersOriginal'));
    }

    render () {
        const { restoreDefaultEnabled, immContract } = this.props;
        const interveners = this.buildIntervenersRows();
        const restoreDefaultLink = restoreDefaultEnabled && immContract.get('intervenersModified') ? this.buildRestoreDefaultIntervenersLink() : null;
        return (
            <div className="junior-interveners">
                <h3 className="ok-informative-list__title">
                    <FormattedText value="contractsView-interveners"/>
                </h3>
                <div className="junior-interveners__titular-section">
                    <p className="junior-interveners__intervener-name">{this.props.juniorName}</p>
                    <FormattedText className="junior-interveners__sublabel" value="contractsView-titular"/>
                </div>
                {interveners}
                {restoreDefaultLink}
            </div>
        );
    }
}

JuniorInterveners.propTypes = {
    juniorName: PropTypes.string.isRequired,
    immContract: PropTypes.object.isRequired,
    immJuniorInterveners: PropTypes.object.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    onExclude: PropTypes.func.isRequired,
    restoreDefaultEnabled: PropTypes.bool,
    restoreDefaultInterveners: PropTypes.func
}

module.exports = JuniorInterveners;